export default __webpack_public_path__ + "static/image8-75d9cbe447d0fabd3f1466d5215ac7e3.gif";